import React, { useContext, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import ObjectIconImg from "../ObjectIconImg";
import fetcher from "../../../../dataProvider";
import {
  Link,
  Box,
  Typography,
  Button,
  Slide,
  List,
  ListItem,
  Divider,
  Select,
  MenuItem,
  InputLabel,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Modal,
  TextField,
} from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import CommunityChannel from "../message/channel";
import {
  setMessageRefresh,
  setRefreshThreadMessages,
  setSelectedThread,
  setShowThread,
  setThreadDetails,
  setThreadUnreadNotifications,
} from "../../../../redux/slices/community";
import ThreadMessageBox from "./theradMessagebox";
import moment, { duration } from "moment";
import useCountDown from "../../../../hooks/useCountDown";
import MetaProperties from "../message/list/meta";
import ThreadMessageActionButton from "../message/list/threadMessageAction";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import HitPredictor from "./hitPredictor";
import ReactPlayer from "react-player";
import Image from "next/image";
import { getThreadUnreadMessageList } from "../message/channel/api";
import UnreadMessagesStrip from "../message/list/unreadMessagesStrip";
import { resetLastSeenMessageTimeStamp } from "../message/channel/api";
import EditMessage from "../message/list/edit-message";
import MessageReaction from "../message/list/message-reaction";
import ParentMessage from "../message/list/parent-message";
import { CommonContext } from "../../../../../components/helper/commonContext";
import socketEvents from "../../../../constant/socketEvents";
import nftLandingCss from "../../../../../components/NFTLandingPage/style";
const useStyles = makeStyles((theme) => ({
  sideBarPageContainer: {
    position: "relative",
    display: "block",
    overflow: "auto",
    overflowX: "hidden",
    width: "0px",
    top: "0",
    transition: "0.3s",
    "&.active": {
      width: "420px",
      transition: "0.3s",
    },
    "@media(max-width:767px)": {
      "&.active": {
        width: "100%",
        transition: "0.3s",
      },
    },
  },
  modalSidebarContainer: {
    position: "absolute",
    top: "0",
    width: "100%",
    height: "100%",
    zIndex: "99",
    background: "#fff",
    borderLeft: "1px solid #DDDDDD",
    boxShadow: "0px 0px 10px #ccc",
  },
  threadHeader: {
    position: "relative",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    height: "57px",
    padding: "8px 15px",
    borderBottom: "1px solid #f2f2f2",
    "& h4": {
      fontSize: "16px",
      fontWeight: "600",
    },
  },
  optionIconList: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "120px",
    "& li": {
      padding: "0",
      justifyContent: "flex-end",
    },
  },
  threadBody: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    top: "0",
    bottom: "0",
    justifyContent: "space-between",
    "& label": {
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      marginBottom: "15px",
    },
    '& input[type="checkbox"]': {
      width: "20px",
      height: "20px",
      marginRight: "10px",
    },
    "& h1": {
      fontSize: "28px",
      fontWeight: "600",
    },
    "& > p": {
      fontSize: "14px",
      fontWeight: "400",
      color: "#505050",
    },
    "& > b": {
      color: "#000",
      fontWeight: "500",
    },
    "& div:empty": {
      display: "none",
    },
  },
  EnterThreadName: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "45px",
    fontSize: "12px",
    padding: "0 20px",
    borderRadius: "12px",
    marginBottom: "30px",
    border: "1px solid #ced4da",
  },
  pollInput: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "45px",
    fontSize: "12px",
    padding: "0 20px",
    borderRadius: "12px",
    marginBottom: "10px",
    border: "1px solid #ced4da",
  },

  pollDuration: {
    position: "relative",
    display: "block",
    width: "50%",
    height: "45px",
    fontSize: "12px",
    padding: "0 20px",
    borderRadius: "12px",
    marginBottom: "10px",
    border: "1px solid #ced4da",
    marginTop: "5px",
  },
  contentEditor: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "49px",
    padding: "13px 55px",
    fontSize: "14px",
    borderRadius: "70px",
    background: "#F0F1F3",
    resize: "none",
    border: "none",
  },
  messageContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "0 15px",
    "& img": {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: "1",
    },
    "& .reply": {
      background: "#f0f1f3",
      padding: "5px 15px",
    },
    "& .reply textarea": {
      background: "#fff !important",
    },
    "& .reply .emojiBox": {
      bottom: "54px",
    },
  },
  iconSmily: {
    left: "20px",
  },
  iconSend: {
    right: "20px",
  },
  addMoreLink: {
    position: "relative !important",
    display: "block",
    color: "#E14084 !important",
    textDecoration: "none",
    margin: "20px 0 !important",
    fontSize: "16px",
  },
  userReaction: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
    fontSize: "12px",
    color: "#0000008a",
    position: "relative",
    paddingLeft: "30px",
    marginLeft: "15px",
    "&::before": {
      width: "30px",
      content: "''",
      backgroundImage: "url('/images/community/reply-line.svg')",
      position: "absolute",
      height: "16px",
      left: "0px",
      top: "10px",
    },
  },
  btnPollSubmit: {
    position: "relative !important",
    display: "block !important",
    width: "225px",
    color: "#fff !important",
    background:
      "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    borderRadius: "8px",
    margin: "0 auto !important",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
    background:
      "-webkit-linear-gradient(90.78deg, #b237f6 3.91%, #e94177 96.03%)",
    "-webkitBackgroundClip": "text",
    "-webkitTextFillColor": "transparent",
    fontWeight: "600",
  },
  userImg: {
    height: "16px",
    width: "16px",
    borderRadius: "50%",
    position: "relative",
    overflow: "hidden",
  },
  threadMsgDate: {
    position: "relative",
    display: "block",
    textAlign: "center",
    "& span": {
      position: "relative",
      display: "inline-block",
      padding: "4px 20px",
      background: "#F1F1F1",
      borderRadius: "8px",
      textAlign: "center",
    },
  },
  userActionInfo: {
    width: "100% !important",
  },
  userInfo: {
    display: "flex",
    alignItems: "flex-start",
    columnGap: "10px",
  },
  userNameDT: {
    position: "relative",
    display: "block",
    wordBreak: "break-all",
  },
  userName: {
    fontSize: "12px !important",
    fontWeight: "700 !important",
    margin: "0 0 7px !important",
    "& small": {
      fontSize: "10px",
    },
  },
  userDT: {
    fontSize: "12px !important",
    margin: "0 !important",
    "& p": {
      marginBottom: "0",
    },
  },
  bodyContentScroll: {
    position: "relative",
    width: "100%",
    overflow: "auto",
    padding: "0 15px 15px",
  },
  polldivder: {
    marginTop: "10px !important",
    marginBottom: "20px !important",
    display: "block",
    color: "red",
    background: "rgba(192, 192, 192, 0.2)",
  },

  handleTitle: {
    width: "414px",
    height: "27px",
    flex: "none",
    order: "1",
    flexGrow: "0",
  },
  textTitle: {
    width: "29px",
    height: "17px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "17px",
    color: "#000000",
    opacity: "0.54",
  },
  pollTitle: {
    width: "25px",
    height: "17px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "17px",
    color: "#E14084",
  },
  pollImg: {
    left: "12.5%",
    right: "12.5%",
    top: "12.5%",
    bottom: "12.5%",
  },
  inputPollContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "end",
    overflow: "auto",
    overflowX: "hidden",
    background: "#fff",
    height: "100%",
    padding: "15px",
  },
  pollForm: {
    overflow: "auto",
    marginBottom: "20px",
    padding: "0 15px 0",
  },
  todayPoll: {
    position: "relative",
    display: "block",
    padding: "20px",
    margin: "20px auto",
    width: "100%",
    textAlign: "center",
    maxWidth: "350px",
    background: "#F7F7F7",
    borderRadius: "10px",
    "& h2": {
      fontSize: "20px",
      fontWeight: "600",
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "600",
      // marginTop: "18px",
      textAlign: "left",
      marginBottom: "10px",
    },
    "@media(max-width:480px)": {
      maxWidth: "100%",
      margin: "0",
    },
  },

  pollOptions: {
    position: "relative",
    display: "block",
    padding: "0",
    "& li": {
      position: "relative",
      display: "block",
      width: "100%",
      padding: "9px 15px",
      background: "#fff",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.23)",
      borderRadius: "12px",
      marginBottom: "12px",
      fontSize: "12px",
    },
  },
  pollIndicatorOptions: {
    position: "relative",
    display: "block",
    padding: "0",
    "& li": {
      position: "relative",
      display: "block",
      width: "100%",
      padding: "0",
      marginBottom: "20px",
      fontSize: "12px",
      "& > div span:nth-child(2)": {
        transition: "0.3s",
        fontSize: "16px",
      },
      "&:hover > div span:nth-child(2)": {},
    },
  },
  optionContent: {
    position: "relative",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    marginBottom: "5px",
  },
  linearProgressBar: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "6px !important",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.23)",
  },
  pollAnswer: {
    position: "relative",
    display: "block",
    width: "100%",
    fontSize: "12px",
    fontWeight: "600",
    marginTop: "30px",
  },
  pollMusicOptions: {
    position: "relative",
    display: "block",
    padding: "0",
    "& li": {
      position: "relative",
      display: "block",
      width: "100%",
      padding: "0",
      "& label": {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: "9px 15px",
        background: "#fff",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.23)",
        borderRadius: "12px",
        overflow: "hidden",
        marginBottom: "12px",
        fontSize: "12px",
        "&:hover ": {
          background: "rgba(225, 64, 132, 0.1)",
        },
      },
      "& label div": {
        width: "100%",
      },
      "& label div img": {
        marginRight: "10px",
      },
      '& label input[type="radio"]': {
        "-webkit-appearance": "none",
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        background:
          "center/cover no-repeat url('/images/community/disable-check.svg')",
      },
      '& label input[type="radio"]:checked': {
        background:
          "center/cover no-repeat url('/images/community/enable-check.svg')",
      },
      '& label input[type="radio"]:checked::before': {
        content: '""',
        position: "absolute",
        left: "0",
        right: "0",
        top: "0",
        bottom: "0",
        background: "#f5e5eb",
        borderRadius: "12px",
        border: "1px solid #E14084",
        mixBlendMode: "darken",
      },
    },
  },
  tabContainer: {
    display: "flex",
    position: "relative",
    maxWidth: "600px",
    "& .Mui-selected": {
      color: "#e14084 !important",
    },
    "& .MuiTabs-flexContainer": {
      width: "100%",
      justifyContent: "space-between",
    },
  },
  tabContentBox: {
    display: "block",
    position: "relative",
    padding: "60px 15px",
    textAlign: "center",
  },
  tab: {
    color: "#fff",
    textTransform: "capitalize !important",
    flexDirection: "row !important",
    minHeight: "36px !important",
    "&:focus": {
      outline: "none",
    },
    "& img": {
      margin: "0 5px 0 0 !important",
      width: "16px",
      height: "16px",
    },
    "@media (max-width: 480px)": {
      maxWidth: "110px",
      fontSize: "16px",
    },
  },
  musicPlayer: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "6px !important",
  },
  hitPredictorList: {
    position: "relative",
    display: "block",
    "& li": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "12px 20px",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      boxShadow:
        "0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802)",
      borderRadius: "10px",
      marginBottom: "16px",
      "& img": {
        width: "70px",
        height: "70px",
        maxWidth: "initial",
        borderRadius: "20px",
      },
      "& h4": {
        fontWeight: "600",
        fontSize: "16px",
        color: "rgba(0,0,0,0.9)",
      },
      "& p": {
        fontWeight: "400",
        fontSize: "14px",
        color: "rgba(0,0,0,0.9)",
      },
      "& a": {
        textDecoration: "none",
        color: "#B0B0B0",
      },
      "& strong": {
        position: "absolute",
        top: "5px",
        left: "5px",
        fontWeight: "700",
        fontSize: "20px",
        color: "#000",
        opacity: "0.2",
      },
    },
    "& li.active": {
      border: "1px solid #E14084",
      "& h4": {
        color: "#E14084",
      },
      "& strong": {
        opacity: "1",
      },
      "& a": {
        color: "#E14084",
      },
    },
  },
  playIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "25px !important",
    height: "25px !important",
  },
  playerContainer: {
    position: "relative",
    display: "flex",
    alignItems: "end",
    "& time": {
      fontSize: "10px",
      padding: "0 5px",
      whiteSpace: "nowrap",
      color: "#0F1E36",
      opacity: "0.5",
      position: "relative",
      top: "5px",
    },
    "& img": {
      width: "15px !important",
      height: "15px !important",
      borderRadius: "0 !important",
      marginRight: "5px",
    },
  },
  videoScreen: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: "99",
    width: "300px",
    height: "217px",
  },
  congratsMsg: {
    position: "relative",
    display: "block",
    padding: "10px 0",
    background: "rgba(84, 181, 187, 0.1)",
    border: "1px solid #4BAF55",
    borderRadius: "8px",
    color: "#48B16E",
    textAlign: "center",
  },
  threadProfiledetails: {
    display: "flex",
    " & p": {
      fontSize: "16px !important",
      marginLeft: "10px",
      justifyContent: "center",
    },
    "& small": {
      padding: "0px 40px 0px",
      fontSize: "10px",
      fontWeight: "400",
    },
  },
  modalContainer: {
    position: "relative",
    display: "block",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "465px",
    background: "#fff",
    borderRadius: "8px",
    padding: "30px 22px 15px",
    "& h4": {
      fontSize: "20px",
      fontWeight: "600",
      color: "#000",
      width: "100%",
      textAlign: "center",
      marginBottom: "8px",
    },
    "& span": {
      position: "relative",
      display: "block",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "22px",
      textAlign: "center",
      marginBottom: "24px",
    },
    "& img": {
      textAlign: "center !important",
      position: "absolute !important",
      top: "10px !important",
      right: "10px !important",
      cursor: "pointer !important",
    },
    "@media(max-width:480px)": {
      width: "90%",
    },
  },
  modalBtnContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& button": {
      position: "relative",
      textAlign: "center",
      display: "block",
      width: "180.5px ",
      maxWidth: "180px",
      padding: "8px 20px",
      height: "44px",
      margin: "0 12px",
      textTransform: "capitalize",
      borderRadius: "8px",
      border: "1px solid transparent",
      fontWeight: "600",
      fontSize: "14px",
    },
  },
  btnCancel: {
    borderColor: "#4f4f4f !important",
    color: "#4f4f4f !important",
  },
  btnDeleteMessgae: {
    border: "none !important",
    background:
      "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    color: "#fff !important",
  },
  msgOverflowScroll: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "512px",
    background: "#fff",
    margin: "auto",
    padding: "40px 40px",
    borderRadius: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    "& img": {
      zIndex: "2",
      position: "absolute",
      top: "15px",
      right: "15px",
      height: "13px",
      width: "13px",
      cursor: "pointer",
    },
    "&  textarea": {
      resize: "none",
      fontSize: "14px",
      minHight: "150px",
      marginBottom: "15px",
      "&:focus": {
        boxShadow: "none",
        borderColor: "#ced4da",
      },
    },

    "@media(max-width:767px)": {
      width: "90%",
      padding: "15px",
    },
  },
  modalContainerImg: {
    position: "relative",
    display: "block",
    top: "100px",
    margin: "auto",
    // transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "600px",
    background: "#000",
    borderRadius: "8px",
    // padding: "30px 22px 15px",

    "& img": {
      textAlign: "center",
      position: "relative",
      display: "block",
      margin: "auto",
      cursor: "pointer",
    },
    "@media(max-width:480px)": {
      width: "90%",
    },
  },
  modalContainervideo: {
    position: "relative",
    display: "block",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    background: "#000",
    borderRadius: "8px",

    "& span": {
      position: "relative",
      display: "block",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "22px",
      textAlign: "center",
      marginBottom: "24px",
    },
    "& img": {
      textAlign: "center !important",
      position: "absolute !important",
      top: "10px !important",
      right: "10px !important",
      cursor: "pointer !important",
    },
    "@media(max-width:480px)": {
      width: "90%",
    },
  },
  reactPlayercss: {
    "& video": {
      transform: "none",
      pointerEvents: "none",
    },
  },
  reactPlayercssvideo: {
    width: "100%",
    "& video": {
      transform: "none",
    },
  },
}));
const CommunityMember = ({ isMobile, goTo, channel, community, user }) => {
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#54B5BB" : "#fff",
    },
  }));
  const BorderLinearProgress2 = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#E14084" : "#fff",
    },
  }));

  const dispatch = useDispatch();
  const {
    showThread,
    createMessageThreadId,
    selectedThread,
    threadDetails,
    currentChannel,
    refreshThreadMessages,
    displayRightPinnedThread,
    rightPinnedThreadDetails,
    threadUnreadNotifications,
  } = useSelector((state) => state.community);
  const { userData } = useSelector((state) => state.user);
  const classes = useStyles();
  const itemRef = useRef(null);
  const closeThreadPopup = () => {
    dispatch(setShowThread(false));
    if (displayRightPinnedThread && rightPinnedThreadDetails != null) {
      dispatch(setSelectedThread(displayRightPinnedThread));
      dispatch(setThreadDetails(rightPinnedThreadDetails));
    }
    if (isMobile) {
      goTo("message");
    }
  };
  // const closeThreadPopup = () => createThread(false);
  const commonContext = useContext(CommonContext);
  const socket = commonContext.socket;

  const [showPoll, createPoll] = useState(false);
  const openPollPopup = () => createPoll(true);
  const closePollPopup = () => createPoll(false);

  const [fade, showHitPredict] = useState(true);

  const [showFavouriteSinger, pollMsgDetails] = useState(false);
  const openPollMsgDetails = () => pollMsgDetails(true);
  const closePollMsgDetails = () => pollMsgDetails(false);

  const [currentCommunity, setCurrentCommunity] = useState(null);
  const [roleList, setRoleList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);
  const [threadName, setThreadName] = useState("");
  const [threadObj, setThreadObj] = useState({});
  const [pollQuestion, setPollQuestion] = useState();
  const [pollDuration, setPollDuration] = useState(0);
  const [sectionFilter, setSectionFilter] = useState("text");
  const [createPopupClose, setCreatePopupClose] = useState(false);
  const [pollThreadName, setPollThreadName] = useState("");
  const currentCommunityState = useSelector((state) => state.community.current);
  const [threadMessageList, setThreadMessageList] = useState([]);
  const [threadUnreadMessageList, setThreadUnreadMessageList] = useState([]);
  const [displayThreadMessageList, setDisplayThreadMessageList] = useState([]);
  const [loadingUnreadList, setLoadingUnreadList] = useState(false);
  const [threadUnreadCount, setThreadUnreadCount] = useState(0);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [unseenThreadMessageList, setUnseenThreadMessageList] = useState([]);
  const [newMessageToThread, setNewMessageToThread] = useState(null);
  const [open, setOpen] = useState(false);
  const [deleteThreadMessageindex, setDeleteThreadMessageindex] = useState(0);
  const [deleteThreadmessageArray, setDeleteThreadmessageArray] = useState([]);
  const [show, setShow] = useState(false);

  const { mutate: getCommunityRolesList } = useMutation((id) =>
    fetcher.get(`/v1/role?communityId=${id}`)
  );
  const { mutate: getCommunityUserList } = useMutation((payload) =>
    fetcher.get(`/v1/community/${payload.id}/members?page=${payload.page}`)
  );

  useEffect(() => {
    if (currentCommunityState) {
      setCurrentCommunity(currentCommunityState);
      getCommunityRole(currentCommunityState);
      setTotalRecord(0);
      setCurrentPage(0);
      setUserList([]);
    }
  }, [currentCommunityState]);

  const getCommunityRole = (item) => {
    getCommunityRolesList(item.id, {
      onSuccess: (res) => {
        setRoleList(res.results);
      },
      onError: (err) => {},
    });
  };
  const getCommunityUser = (item, page) => {
    getCommunityUserList(
      { id: item.id, page: page },
      {
        onSuccess: (res) => {
          setCurrentPage(currentPage + 1);
          setUserList([...userList, ...res.results]);
          setTotalRecord(res.totalResults);
        },
        onError: (err) => {},
      }
    );
  };
  const handleViewAllMember = (e) => {
    e.preventDefault();
    getCommunityUser(currentCommunity, currentPage);
  };

  const initialAvailableOption = [
    { result: "" },
    { result: "" },
    { result: "" },
    { result: "" },
  ];
  const [availableOption, setAvailableOption] = useState(
    initialAvailableOption
  );

  const setPollOption = (index, e) => {
    let data = availableOption;
    data[index].result = e.target.value;
    setAvailableOption([...data]);
  };

  const handleChange = (e) => {
    setThreadName(e.target.value);
  };

  useEffect(() => {
    if (threadName) {
      let updateThreadObj = { name: threadName };
      if (createMessageThreadId) {
        updateThreadObj.messageId = createMessageThreadId;
      }
      setThreadObj(updateThreadObj);
    }
  }, [threadName]);

  const { mutate: createNewThread } = useMutation(
    ({ communityid, channelid, data }) =>
      fetcher.post(
        `/v1/community/${communityid}/community-channel/${channelid}/thread`,
        data
      ),
    {
      onSuccess: (response) => {
        // console.log("thread created ", response);
        setThreadName("");
        dispatch(setThreadDetails({ meta: response }));
        dispatch(setSelectedThread(response?._id));
        dispatch(setMessageRefresh(true));
      },
      onError: (error) => {
        // console.log("thread could not be created ", error);
      },
    }
  );

  const { mutate: getThreadMessages } = useMutation(
    (data) =>
      fetcher.get(
        `/v1/message?channelId=${data.channelId}&threadId=${data.threadId}&limit=100&updateLastSeen=true`
      ),
    {
      onSuccess: (data) => {
        setThreadMessageList(data?.result?.reverse());
        scrollMessageList();
      },
      onError: (error) => {
        // console.log("thread messages ", error);
      },
    }
  );

  const scrollMessageList = () => {
    setTimeout(() => {
      if (itemRef.current) {
        itemRef.current.scrollIntoView(false);
      }
    }, 500);
  };
  // console.log("print Poll Object ==", pollDuration);
  const { mutate: createNewPollApi } = useMutation(
    (createPollObject) => fetcher.post(`/v1/message`, createPollObject),
    {
      onSuccess: (res) => {
        setAvailableOption(initialAvailableOption);
        setPollThreadName("");
        setPollQuestion("");
        getThreadMessages(
          {
            channelId: currentChannel?._id,
            threadId: selectedThread,
          },
          {
            onSuccess: (response) => {},
            onError: (error) => {
              // console.log("error", error);
            },
          }
        );
      },
      onError: (error) => {
        // console.log("print error ==", error);
      },
    }
  );

  const refreshMessages = () => {
    getThreadMessages({
      channelId: currentChannel?._id,
      threadId: selectedThread,
    });
    dispatch(setRefreshThreadMessages(false));
  };

  useEffect(() => {
    if (refreshThreadMessages) {
      refreshMessages();
    }
  }, [refreshThreadMessages]);

  const viewUnseenThreadMessages = () => {
    console.log("view unseen messages");
    setThreadMessageList([
      ...displayThreadMessageList,
      ...unseenThreadMessageList.reverse(),
    ]);
    setUnseenThreadMessageList([]);
    if (itemRef && itemRef?.current) {
      setTimeout(() => {
        if (itemRef.current) itemRef.current.scrollIntoView();
      }, 500);
    }
  };

  useEffect(() => {
    console.log("Inside socket get_message event");

    if (socket != null && socket.connected) {
      socket.on(socketEvents.GET_THREAD_MESSAGE, (messageList) => {
        console.log("Message List : ", messageList[0]);
        // setUnseenThreadMessageList((prev) => [messageList[0], ...prev]);
        setNewMessageToThread(messageList[0]);
      });
    }

    return () => {
      if (socket != null && socket.connected) {
        socket.off(socketEvents.GET_THREAD_MESSAGE);
      }
    };
  }, [commonContext.socketId]);

  useEffect(() => {
    if (newMessageToThread != null) {
      let senderId = newMessageToThread?.user?._id;
      if (userData?.id == senderId) {
        setThreadMessageList([
          ...displayThreadMessageList,
          ...unseenThreadMessageList.reverse(),
          newMessageToThread,
        ]);
        setUnseenThreadMessageList([]);
        setThreadUnreadMessageList([]);

        setTimeout(() => {
          console.log("itemRef.current:\n", itemRef);
          if (itemRef.current) itemRef.current.scrollIntoView();
        }, 500);
      } else {
        setUnseenThreadMessageList((prev) => [newMessageToThread, ...prev]);
      }
    }
  }, [newMessageToThread]);
  // result date for hit predictor

  const [resultDate, setResultDate] = useState("");
  const [eventLiveDate, setEventLiveDate] = useState("");

  // create Poll on Submit
  const createNewPoll = (type) => {
    if (type == "POLL") {
      if (pollThreadName && pollDuration) {
        createNewThread(
          {
            communityid: community,
            channelid: channel,
            data: { name: pollThreadName },
          },
          {
            onSuccess: (response) => {
              let CreatePollobj = {
                type: "poll",
                text: pollQuestion,
                channelId: channel,
                threadId: response?._id,
                pollDurationMinutes: 24 * 60 * pollDuration,
              };
              let options = [];
              options = availableOption
                .filter((item) => item?.result != "")
                .map((item) => {
                  return { option: item?.result };
                });
              CreatePollobj.pollOptions = options;
              createNewPollApi(CreatePollobj);
            },
            onError: (error) => {
              // console.log("poll thread created  error", error);
            },
          }
        );
      }
    } else if (type == "HIT_PREDICTOR") {
      if (pollThreadName && pollDuration) {
        createNewThread(
          {
            communityid: community,
            channelid: channel,
            data: { name: pollThreadName },
          },
          {
            onSuccess: (response) => {
              // convert to ISO simialr to creatd Time
              var dateAndTime = new Date(eventLiveDate);
              var EventFinalDateAndTime = dateAndTime.toISOString();
              console.log("Print dateAndTime:\n ", EventFinalDateAndTime);
              let CreatePollobj = {
                type: "predictor",
                text: pollQuestion,
                channelId: channel,
                threadId: response?._id,
                predictorDurationMinutes: 24 * 60 * pollDuration,
                predictorResultDate: resultDate,
                predictorEventDate: EventFinalDateAndTime,
              };

              console.log("Print value CreatePollobj: ", CreatePollobj);
              let options = [];
              options = availableOption
                .filter((item) => item?.result.split("||").length == 3)
                .map((item) => {
                  let optionData = item?.result.split("||");
                  let optionObject = {
                    youtubeId: optionData[0].trim(),
                    songName: optionData[1].trim(),
                    singerName: optionData[2].trim(),
                    songType: "video",
                    songUrl: "",
                    albumName: "",
                    albumImageUrl: "",
                    isCorrect: false,
                  };
                  return optionObject;
                });
              CreatePollobj.predictorOptions = options;
              createNewPollApi(CreatePollobj);
            },
            onError: (error) => {
              // console.log("poll thread created  error", error);
            },
          }
        );
      }
    }
  };

  const handleKeyDownSend = (e) => {
    if (e.key === "Enter") {
      handleSend();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      createNewThread({
        communityid: community,
        channelid: channel,
        data: threadObj,
      });
    }
  };

  const updateThreadUnreadMessageList = async (channelId, threadId) => {
    setLoadingUnreadList(true);
    if (channelId && threadId) {
      let response = await getThreadUnreadMessageList(channelId, threadId);
      if (response) {
        setThreadUnreadMessageList(response.reverse());
        setThreadUnreadCount(response?.length);
      }
    }
    setLoadingUnreadList(false);
  };

  useEffect(() => {
    if (selectedThread && currentChannel) {
      setThreadMessageList([]);
      setThreadUnreadMessageList([]);
      setThreadUnreadCount(0);
      setDisplayThreadMessageList([]);
      setUnseenThreadMessageList([]);
      setSelectedOption(0);
      setLoadingUnreadList(false);
      getThreadMessages({
        channelId: currentChannel?._id,
        threadId: selectedThread,
      });
      updateThreadUnreadMessageList(currentChannel?._id, selectedThread);
    }
  }, [selectedThread, currentChannel]);

  useEffect(() => {
    console.log(
      "socket changing inside thread emits",
      socket?.id,
      socket?.connected
    );
    if (selectedThread && currentChannel) {
      if (socket != null) {
        console.log(
          "socket subscribing to inside thread ",
          selectedThread,
          socket.id,
          socket.connected
        );
        socket.emit(socketEvents.SUBSCRIBE_TO_THREAD, {
          channelId: currentChannel?._id,
          threadId: selectedThread,
        });
        console.log(
          "socket subscribed to thread : ",
          selectedThread,
          socket.id,
          socket.connected
        );
      }
    }
    return () => {
      if (selectedThread && currentChannel) {
        if (socket != null) {
          socket.emit(socketEvents.UNSUBSCRIBE_TO_THREAD, {
            channelId: currentChannel?._id,
            threadId: selectedThread,
          });
          console.log("socket unsubscribed to thread : ", socket.id);
        }
      }
    };
  }, [selectedThread, currentChannel, commonContext.socketId]);

  const [message, setMessage] = useState("");

  const { mutate: sendMessageToChannel } = useMutation(
    (data) => fetcher.post(`/v1/message`, data),
    {
      onSuccess: (response) => {
        setMessage("");
        dispatch(setMessageRefresh(true));
        getThreadMessages({
          channelId: currentChannel?._id,
          threadId: selectedThread,
        });
      },
      onError: (error) => {
        // console.log("could not sent message to channel");
      },
    }
  );

  const handleSend = () => {
    if (message.trim()?.length > 0) {
      let _data = {
        type: "text",
        text: message,
        channelId: currentChannel._id,
      };
      if (selectedThread) {
        _data.threadId = selectedThread;
      }
      sendMessageToChannel(_data);
    }
  };

  const updatePollResult = () => {
    setAvailableOption([...availableOption, { result: "" }]);
  };

  const [selectedOption, setSelectedOption] = useState(0);
  const { mutate: sendResponseToPoll } = useMutation(
    (data) =>
      fetcher.post(`/v1/message/${data.messageId}/poll-response`, {
        optionId: data.optionId,
      }),
    {
      onSuccess: (response) => {
        console.log("response:", response);
      },
      onError: (error) => {},
    }
  );

  const addPollResponse = (messageId, optionId) => {
    console.log("print value");
    if (selectedOption == optionId) {
      setSelectedOption(null);
    } else {
      setSelectedOption(optionId);
    }
    sendResponseToPoll({ messageId, optionId });
  };

  const [value, setValue] = React.useState(0);
  const handleTabs = (e, val) => {
    setValue(val);
  };

  const getPollPercentage = (options, option) => {
    if (options.length && option) {
      const totalRespone = options.reduce(
        (sum, item) => sum + item?.responseCount,
        0
      );

      return (option?.responseCount / totalRespone) * 100;
    }
    return 0;
  };

  const hasPollEnded = (endDate) => {
    const today = new Date();
    const endsAt = new Date(endDate);
    const todayInGmt = new Date(today.toUTCString());
    if (endsAt.getTime() - todayInGmt.getTime() < 0) {
      return true;
    } else {
      return false;
    }
  };

  const getMessageSubstr = (msg) => {
    if (typeof msg != "undefined") {
      if (isMobile) {
        let len = 21;
        if (msg.length > len) {
          let msgTextArr = msg.substring(0, len).lastIndexOf(" ");
          return (
            msg.substring(0, msgTextArr >= 0 ? msgTextArr + 1 : len) + "..."
          );
        } else {
          return msg;
        }
      } else {
        let len = 24;
        if (msg.length > len) {
          let msgTextArr = msg.substring(0, len).lastIndexOf(" ");
          return (
            msg.substring(0, msgTextArr >= 0 ? msgTextArr + 1 : len) + "..."
          );
        } else {
          return msg;
        }
      }
    } else return msg;
  };

  const PollMessage = ({ message }) => {
    // console.log("message: ", message?.hasResponedToPoll);
    const {
      days = 0,
      hours = 0,
      minutes = 0,
      seconds = 0,
    } = useCountDown(message?.pollEndDate);

    const isPollEnded = hasPollEnded(message?.pollEndDate);
    let responseArr =
      message?.pollOptions?.map((item) => item?.responseCount) || [];
    let max = Math.max(...responseArr);
    const maxIndex = responseArr.indexOf(max);
    return (
      <Box className={classes.todayPoll}>
        <Typography component="p"> {message?.text} </Typography>

        {/* ======Option List Start======= */}

        {!isPollEnded ? (
          <List className={classes.pollMusicOptions}>
            {message?.pollOptions?.map((item, key) => {
              return (
                <ListItem
                  key={key}
                  sx={{
                    cursor:
                      !message?.hasResponedToPoll && !selectedOption
                        ? "pointer"
                        : "default",
                  }}
                  onClick={() => {
                    console.log("funtion called:: ");
                    getThreadMessages({
                      channelId: message?.channelId,
                      threadId: message?.threadId,
                    });
                    addPollResponse(message?._id, item?._id);
                  }}
                >
                  <label htmlFor="option1">
                    <Box className={classes.playIcons}>
                      <Typography variant="span" sx={{ fontSize: "16px" }}>
                        {item?.option}
                      </Typography>
                    </Box>
                    <input
                      id="option1"
                      name="songPoll"
                      type="radio"
                      style={{ marginLeft: "5px" }}
                      onChange={(e) => {}}
                      // disabled={
                      //   !message?.hasResponedToPoll && !selectedOption
                      // }
                      checked={
                        message?.hasResponedToPoll === true
                          ? item?._id == message?.pollResponseOption ||
                            item?._id == selectedOption
                          : false
                      }
                    />
                  </label>
                </ListItem>
              );
            })}
          </List>
        ) : (
          <List className={classes.pollIndicatorOptions}>
            {message?.pollOptions.map((item, key) => {
              const pollPercentage = getPollPercentage(
                message?.pollOptions,
                item
              );
              return (
                <ListItem key={key}>
                  <Box className={classes.optionContent}>
                    <Typography
                      variant="span"
                      sx={{ fontSize: "16px !important" }}
                    >
                      <span>{item?.option}</span>
                    </Typography>
                    <Typography
                      variant="span"
                      sx={{
                        marginLeft: "15px !important",
                        fontWeight: key == maxIndex ? "bold" : "",
                      }}
                    >
                      {pollPercentage.toFixed(2)}%
                    </Typography>
                  </Box>

                  <BorderLinearProgress
                    className={classes.linearProgressBar}
                    variant="determinate"
                    value={pollPercentage}
                  />
                </ListItem>
              );
            })}
          </List>
        )}
        {!isPollEnded && (
          <Box>
            <Typography
              variant="p"
              style={{ fontSize: "16px", fontWeight: "500" }}
            >
              Poll ends in{" "}
            </Typography>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{ color: "#000", fontSize: "16px", fontWeight: "500" }}
                    align="center"
                  >
                    <Typography variant="h5" sx={{ fontSize: "16px" }}>
                      {days}
                    </Typography>
                    <Typography component="x-small" sx={{ fontSize: "16px" }}>
                      Days
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{ color: "#000", fontSize: "16px", fontWeight: "500" }}
                    align="center"
                  >
                    <Typography variant="h5" sx={{ fontSize: "16px" }}>
                      {hours}
                    </Typography>
                    <Typography component="x-small" sx={{ fontSize: "16px" }}>
                      Hours
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{ color: "#000", fontSize: "16px", fontWeight: "500" }}
                    align="center"
                  >
                    <Typography variant="h5" sx={{ fontSize: "16px" }}>
                      {minutes}
                    </Typography>
                    <Typography component="x-small" sx={{ fontSize: "16px" }}>
                      Min
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{ color: "#000", fontSize: "16px", fontWeight: "500" }}
                    align="center"
                  >
                    <Typography variant="h5" sx={{ fontSize: "16px" }}>
                      {seconds}
                    </Typography>
                    <Typography component="x-small" sx={{ fontSize: "16px" }}>
                      Sec
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        )}
      </Box>
    );
  };

  const MessageDetail = ({ item, isMobile = false }) => {
    const classes = useStyles();
    const [isSongPlaying, setIsSongPlaying] = useState(false);
    const [playedSeconds, setPlayedSeconds] = useState(0);
    const [totalDuration, setToalDuration] = useState(0);
    const [openVideo, setOpenVideo] = useState(false);
    const [openImg, setOpenImg] = useState(false);

    console.log("Print thread Message details ====", item);

    return (
      <>
        {item?.type === "text" && (
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            className="line-break-mark"
          >
            {item?.text}
          </ReactMarkdown>
        )}
        {item?.attachments.length > 0 &&
          item?.attachments?.[0]?.mime.includes("image") && (
            <Box
              component="img"
              style={{
                width: "80%",
                height: "300px",
                objectFit: "contain",
                cursor: "pointer",
              }}
              src={item?.attachments?.[0]?.url}
              onClick={() => setOpenImg(true)}
            />
          )}
        {item?.attachments.length > 0 &&
          item?.attachments?.[0]?.mime.includes("video") && (
            <Box
              className={classes.reactPlayercss}
              onClick={() => setOpenVideo(true)}
              style={{ cursor: "pointer" }}
            >
              {/* <ReactPlayer
                onProgress={(progress) => {
                  console.log(
                    "Print progress value in video plyaer:",
                    progress
                  );
                  setPlayedSeconds(progress?.playedSeconds);
                }}
                url={item?.attachments?.[0]?.url}
                width={isMobile ? "100%" : "430px"}
                height={isMobile ? "230px" : "230px"}
                background={"transparent"}
                playing={isSongPlaying}
                controls
                onPause={() => {
                  setIsSongPlaying(false);
                }}
                onPlay={() => {
                  setIsSongPlaying(true);
                }}
                onDuration={(duration) => {
                  setToalDuration(duration);
                }}
                config={{
                  file: {
                    attributes: { controlsList: "nodownload" },
                  },
                }}
              /> */}
              <video
                width={isMobile ? "100%" : "750"}
                height={isMobile ? "300" : "500"}
                style={{ objectFit: "contain" }}
                controls
              >
                <source
                  src={item?.attachments?.[0]?.url}
                  type={item?.attachments?.[0]?.mime.includes("video")}
                />
              </video>
            </Box>
          )}

        {item?.metaProperties && item?.metaProperties?.length > 0 && (
          <MetaProperties meta={item?.metaProperties} isMobile={isMobile} />
        )}
        {item?.type === "gif" && (
          <img src={item?.text} className="gif_msg" alt="" />
        )}
        {item?.reactionsAggregated && item?.reactionsAggregated.length > 0 && (
          <MessageReaction
            reaction={item?.reactionsAggregated}
            msgId={item?._id}
          />
        )}

        {/* thread messageList image  popup display */}
        <Modal
          open={openImg}
          onClose={() => setOpenImg(false)}
          disableScrollLock={true}
        >
          <Box className={classes.modalContainerImg}>
            <Box
              component="img"
              style={{
                width: "100%",
              }}
              src={item?.attachments?.[0]?.url}
            />
          </Box>
        </Modal>

        {/*thread messageList Video popup display */}
        <Modal
          open={openVideo}
          onClose={() => setOpenVideo(false)}
          disableScrollLock={true}
        >
          <Box className={classes.modalContainervideo}>
            <Box className={classes.reactPlayercssvideo}>
              <video
                width="100%"
                style={{ objectFit: "contain" }}
                controls
                autoPlay
              >
                <source
                  src={item?.attachments?.[0]?.url}
                  type={item?.attachments?.[0]?.mime.includes("video")}
                />
              </video>
            </Box>
          </Box>
        </Modal>
      </>
    );
  };

  const { mutate: deleteMessage } = useMutation((id) =>
    fetcher.delete(`/v1/message/${id}`, {})
  );

  const { mutate: editMessage } = useMutation(({ id, data }) =>
    fetcher.patch(`/v1/message/${id}`, data)
  );

  const { mutate: addMessageReaction } = useMutation(({ id, data }) =>
    fetcher.post(`/v1/message/${id}/reaction`, data)
  );

  const handleOpen = (index, item) => {
    console.log("handle Thread delete message", index, item);
    setDeleteThreadMessageindex(index);
    setDeleteThreadmessageArray(item);
    setOpen(true);
  };

  const handleClose = (index, item) => {
    console.log("print delete message id", item, item);
    handleDelete(index, item);
    setOpen(false);
  };

  const handleDelete = (index, item) => {
    console.log("print delete message id", item?._id);
    setOpen(true);
    // if (window.confirm("Are you want to sure delete ?")) {
    deleteMessage(item._id, {
      onSuccess: () => {
        displayThreadMessageList.splice(index, 1);
        // dispatch(setThreadMessageList(displayThreadMessageList));
        // dispatch(setMessageRefresh(true));
      },
      onError: () => {},
    });
    // }
  };

  // thread message reported
  const { mutate: reportMessage } = useMutation((data) =>
    fetcher.post(`/v1/message/${data.id}/report`, data?.reportMessageObj)
  );

  const [open1, setOpen1] = useState(false);
  const [flagmessage, setFlagmessage] = useState();
  const [flagmessageindex, setFlagmessageindex] = useState(0);
  const [flgmessageArray, setFlagmessageArray] = useState([]);

  const handleEnter = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      setFlagmessage("");
      handleClose1(flagmessageindex, flgmessageArray);
    }
  };

  const handleOpen1 = (index, item) => {
    console.log("handle open1  handlerr", index, item);
    setFlagmessageindex(index);
    setFlagmessageArray(item);
    setOpen1(true);
  };

  const handleClose1 = (index, item) => {
    console.log("handle close1  handlerr", index, item);
    handleMessageReport(index, item);
    setOpen1(false);
  };

  const handleMessageReport = (index, item) => {
    // let reportedMessage = prompt("Please enter for reported Message Comment");
    console.log("starting function ", index, item);
    setOpen1(true);
    console.log("Message reported" + flagmessage);
    let reportMessageObj = {
      comment: flagmessage,
    };
    console.log("Message reported object", reportMessageObj);
    reportMessage(
      { id: item?._id, reportMessageObj: reportMessageObj },
      {
        onSuccess: (res) => {
          console.log("print response for report message", res);
          refreshData();
          setFlagmessage("");
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  };

  const handleEditSubmit = (index, data) => {
    editMessage(
      { id: selectedMessage._id, data: data },
      {
        onSuccess: (res) => {
          // let _msgList = threadMessageList;
          // _msgList[index] = { ...selectedMessage, ...{ text: data.text } };
          // console.log("Print edit message response:", res);
          // setThreadMessageList(_msgList);
          setSelectedMessage(null);
          dispatch(setRefreshThreadMessages(true));
        },
        onError: (err) => {
          console.log("Print edit Message err", err);
          setSelectedMessage(null);
        },
      }
    );
  };

  const handleReaction = (e, item) => {
    console.log("Primnt thread message list handleReaction:", item);
    if (item?.reactionsAggregated.length < 10) {
      addMessageReaction(
        { id: item?._id, data: { emoji: e?.unified } },
        {
          onSuccess: (response) => {
            console.log("Print response:", response);
          },
          onError: (err) => {
            console.log("Print handleReaction error:", err);
          },
        }
      );
    } else {
      setShow(true);
    }
  };

  useEffect(() => {
    setDisplayThreadMessageList([
      ...threadMessageList,
      ...threadUnreadMessageList,
    ]);
  }, [threadMessageList, threadUnreadMessageList]);

  const resetThreadUnreadCount = (threadId) => {
    if (threadUnreadNotifications?.length) {
      let updatedThreadUnreadNotifications = threadUnreadNotifications.map(
        (item) =>
          item?.threadId == threadId ? { ...item, unreadCount: 0 } : item
      );
      dispatch(setThreadUnreadNotifications(updatedThreadUnreadNotifications));
    }
  };

  const resetLastSeenTimeStamp = async (timeStamp) => {
    if (timeStamp && currentChannel?._id && selectedThread) {
      let response = await resetLastSeenMessageTimeStamp(
        currentChannel?._id,
        timeStamp,
        selectedThread
      );
      if (response?.lastSeenMessageTimestamp) {
        // updateThreadUnreadMessageList(currentChannel?._id, selectedThread);
        resetThreadUnreadCount(selectedThread);
        setThreadUnreadCount(0);
      }
    }
  };

  const [selectedSong, setSelectedSong] = useState(null);
  const [playedSeconds, setPlayedSeconds] = useState(0);
  const [totalDuration, setToalDuration] = useState(0);

  const [isSongPlaying, setIsSongPlaying] = useState(false);

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [songList, setSongList] = useState([]);

  const pauseSong = () => {
    setIsSongPlaying(false);
  };

  const playSong = () => {
    setIsSongPlaying(true);
    setIsOpenModal(true);
  };

  const handleNewSongSelect = (item) => {
    setSelectedSong(item);
    setIsOpenModal(true);
    setIsSongPlaying(true);
  };
  const refreshHitpredictor = (item) => {
    console.log("refreshHitmessages :", item);
    getThreadMessages({
      channelId: item?.channelId,
      threadId: item?.threadId,
    });
  };

  const getRecommendation = (selectedSong) => {
    if (songList.length > 0) {
      let filterdList = songList.filter(
        (item) => item?._id != selectedSong?._id
      );

      let results = filterdList.map(
        (item) => `https://www.youtube.com/watch?v=${item?.youtubeId}`
      );

      return [
        `https://www.youtube.com/watch?v=${selectedSong?.youtubeId}`,

        ...results,
      ];
    } else return [];
  };

  const getUserProfilePic = (name) => {
    if (name) {
      let arr = name?.split(" ");
      if (arr.length > 1) {
        return (
          arr[0]?.toUpperCase()?.substring(0, 1) +
          arr[1]?.toUpperCase()?.substring(0, 1)
        );
      } else {
        return arr[0]?.toUpperCase()?.substring(0, 2);
      }
    }
    return "";
  };

  const jumpToPresent = () => {
    setThreadMessageList([...displayThreadMessageList]);
    setThreadUnreadMessageList([]);
    setThreadUnreadCount(0);
    resetLastSeenTimeStamp(
      displayThreadMessageList[displayThreadMessageList?.length - 1]?.createdAt
    );

    if (itemRef && itemRef?.current) {
      setTimeout(() => {
        if (itemRef.current) itemRef.current.scrollIntoView(false);
      }, 200);
    }
  };

  return (
    <Box
      className={
        showThread || displayRightPinnedThread
          ? `active ${classes.sideBarPageContainer}`
          : classes.sideBarPageContainer
      }
    >
      {/* <div
        className={isMobile ? `community_member mobile` : `community_member`}
      >
        <h5>People</h5>
        {roleList &&
          roleList.length > 0 &&
          roleList.map((item, index) => {
            return (
              <div className="group" key={index}>
                <div
                  className="type"
                  style={{ backgroundColor: item?.colorCode }}
                >
                  {item?.name}
                </div>
                {item?.members &&
                  item?.members?.length > 0 &&
                  item?.members?.map((memberItem, mindex) => (
                    <div className="member" key={mindex}>
                      {memberItem && memberItem?.user && (
                        <ObjectIconImg
                          profilePic={memberItem?.user?.profilePic}
                          name={memberItem?.user?.name}
                          outerClass={"user_img"}
                          innerClass={"user_img_inner"}
                        />
                      )}
                      <p className="name">{memberItem?.user?.name}</p>
                    </div>
                  ))}
              </div>
            );
          })}
        {userList && userList.length > 0 && (
          <>
            <h5 style={{ marginTop: "10px" }}>All Member</h5>
            <div className="group">
              {userList.map((item, index) => {
                return (
                  <div className="member" key={index}>
                    {item && item?.user && (
                      <ObjectIconImg
                        profilePic={item?.user?.profilePic}
                        name={item?.user?.name}
                        outerClass={"user_img"}
                        innerClass={"user_img_inner"}
                      />
                    )}
                    <p className="name">{item?.user?.name}</p>
                  </div>
                );
              })}
            </div>
          </>
        )}
        {(totalRecord === 0 || totalRecord > userList?.length) && (
          <div className="view_all">
            <button type="button" onClick={handleViewAllMember}>
              {totalRecord > userList?.length ? "More" : "View All"}
            </button>
          </div>
        )}
      </div> */}

      {/* =========Sidebar Create Thread PopUp Start */}
      {showThread && selectedThread == null && (
        <Box className={classes.modalSidebarContainer + " slideModalSidebar"}>
          <Box className={classes.threadBody}>
            <Box className={classes.threadHeader}>
              <Typography variant="h4">
                <Box
                  component="img"
                  src="/images/community/hash.svg"
                  width="24"
                  height="24"
                />{" "}
                {sectionFilter == "text" ? "New Thread" : "New Poll"}
              </Typography>
              <List className={classes.optionIconList}>
                <ListItem>
                  <Box width="24" height="24" />
                </ListItem>
                <ListItem>
                  <Box width="24" height="24" />
                </ListItem>
                <ListItem>
                  <Box
                    component="img"
                    onClick={() => closeThreadPopup()}
                    src="/images/community/close.svg"
                    width="24"
                    height="24"
                  />
                </ListItem>
              </List>
            </Box>
            <Tabs
              TabIndicatorProps={{ style: { background: "#e14084" } }}
              sx={classes.tabContainer}
              value={value}
              onChange={handleTabs}
            >
              <Tab
                icon={
                  <Box component="img" src="/images/community/text-tab.svg" />
                }
                label="Text"
                className={classes.tab}
                onClick={() => {
                  setSectionFilter("New Thread");
                }}
              />
              <Tab
                icon={
                  <Box
                    component="img"
                    src="/images/community/thread-song-icon.svg"
                  />
                }
                label="Poll"
                className={classes.tab}
                onClick={() => {
                  setSectionFilter("New Poll");
                }}
              />

              <Tab
                icon={
                  <Box
                    component="img"
                    src="/images/community/thread-song-icon.svg"
                  />
                }
                label="Hit Predictor"
                className={classes.tab}
                onClick={() => {
                  setSectionFilter("New Hit Predictor");
                }}
              />
            </Tabs>
            <TabPanel value={value} index={0} style={{ color: "#fff" }}>
              <Box sx={classes.tabContentBox}>
                <Box className={classes.inputPollContainer}>
                  <Box>
                    <input
                      id="thread"
                      type="text"
                      value={threadName}
                      className={classes.EnterThreadName}
                      placeholder="Enter Thread Name"
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                    />
                    <Divider
                      variant="fullWidth"
                      style={{ marginBottom: "20px", marginTop: "10px" }}
                    />

                    {/* <label htmlFor="people-invite">
                    <input id="people-invite" type="checkbox" required />{" "}
                    <span>Only people you invite and moderator can see</span>
                  </label> */}
                  </Box>
                </Box>
                {/* <Box className={classes.messageContainer}>
                  <ThreadMessageBox threadId={selectedThread} />
                </Box> */}
              </Box>
            </TabPanel>
            <TabPanel value={value} index={1} style={{ color: "#fff" }}>
              <Box sx={classes.tabContentBox}>
                <Box className={classes.inputPollContainer}>
                  <Box className={classes.pollForm}>
                    <input
                      type="text"
                      className={classes.EnterThreadName}
                      placeholder="Enter Thread Name"
                      value={pollThreadName}
                      onChange={(e) => {
                        e.preventDefault();
                        setPollThreadName(e.target.value);
                      }}
                    />

                    <input
                      type="text"
                      className={classes.EnterThreadName}
                      placeholder="Ask a Question..."
                      onChange={(e) => {
                        e.preventDefault();
                        setPollQuestion(e.target.value);
                      }}
                    />

                    <Typography style={{ marginBottom: "10px" }} component="p">
                      <strong>Your options</strong>
                    </Typography>

                    {availableOption.map((item, index) => {
                      return (
                        <>
                          <input
                            key={index}
                            type="text"
                            value={item?.result}
                            className={classes.pollInput}
                            placeholder={"Choice " + (index + 1).toString()}
                            onChange={(e) => {
                              setPollOption(index, e);
                            }}
                          />
                        </>
                      );
                    })}
                    <Divider
                      variant="fullWidth"
                      className={classes.polldivder}
                    />
                    {/* <input type="text" className={classes.pollDuration} placeholder="Poll Duration " onChange={(e)=> {
                              e.preventDefault();
                              setPollDuration(e.target.value)}} 
                          /> */}
                    <InputLabel id="demo-simple-select-label">
                      Poll Duration
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      label="Poll Duration"
                      onChange={(e) => setPollDuration(e.target.value)}
                      style={{ width: "100%" }}
                      displayEmpty
                    >
                      <MenuItem value={0}>Poll Duration</MenuItem>
                      <MenuItem value={1}>1 Day</MenuItem>
                      <MenuItem value={2}>2 Day</MenuItem>
                      <MenuItem value={3}>3 Day</MenuItem>
                      <MenuItem value={4}>4 Day</MenuItem>
                      <MenuItem value={5}>5 Day</MenuItem>
                      <MenuItem value={6}>6 Day</MenuItem>
                      <MenuItem value={7}>7 Day</MenuItem>
                    </Select>
                    <Link
                      href="#"
                      className={classes.addMoreLink}
                      onClick={() => {
                        updatePollResult();
                      }}
                    >
                      + Choice
                    </Link>
                  </Box>
                  {/* <label htmlFor="people-invitePoll">
                  <input id="people-invitePoll" type="checkbox" mandatory />{" "}
                  <span>Only people you invite and moderator can see</span>
                </label> */}
                  <Button
                    className={classes.btnPollSubmit}
                    onClick={(e) => {
                      createNewPoll("POLL");
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            </TabPanel>
            <TabPanel value={value} index={2} style={{ color: "#fff" }}>
              <Box sx={classes.tabContentBox}>
                <Box className={classes.inputPollContainer}>
                  <Box className={classes.pollForm}>
                    <input
                      type="text"
                      className={classes.EnterThreadName}
                      placeholder="Hit Predictor Thread Name"
                      value={pollThreadName}
                      onChange={(e) => {
                        e.preventDefault();
                        setPollThreadName(e.target.value);
                      }}
                    />

                    <input
                      type="text"
                      className={classes.EnterThreadName}
                      placeholder="Enter Hit Predictor Question"
                      onChange={(e) => {
                        e.preventDefault();
                        setPollQuestion(e.target.value);
                      }}
                    />

                    <Typography style={{ marginBottom: "10px" }} component="p">
                      <strong>Your options</strong>
                    </Typography>

                    {availableOption.map((item, index) => {
                      return (
                        <>
                          <input
                            key={index}
                            type="text"
                            value={item?.result}
                            className={classes.pollInput}
                            placeholder="YouTubeId || SongName || SingerName"
                            onChange={(e) => {
                              setPollOption(index, e);
                            }}
                          />
                        </>
                      );
                    })}
                    <Divider
                      variant="fullWidth"
                      className={classes.polldivder}
                    />

                    <InputLabel id="demo-simple-select-label">
                      Poll Duration
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      label="Poll Duration"
                      onChange={(e) => setPollDuration(e.target.value)}
                      style={{ width: "100%" }}
                      displayEmpty
                    >
                      <MenuItem value={0}>Poll Duration</MenuItem>
                      <MenuItem value={1}>1 Day</MenuItem>
                      <MenuItem value={2}>2 Day</MenuItem>
                      <MenuItem value={3}>3 Day</MenuItem>
                      <MenuItem value={4}>4 Day</MenuItem>
                      <MenuItem value={5}>5 Day</MenuItem>
                      <MenuItem value={6}>6 Day</MenuItem>
                      <MenuItem value={7}>7 Day</MenuItem>
                    </Select>

                    <TextField
                      id="date"
                      label="Result day"
                      type="date"
                      defaultValue={resultDate}
                      InputLabelProps={{
                        shrink: true,
                        fontSize: "18px",
                      }}
                      onChange={(e) => {
                        setResultDate(e.target.value);
                      }}
                      sx={{ marginTop: "25px", width: "200px" }}
                    />
                    <TextField
                      id="date"
                      label="Event Live day Time"
                      type="datetime-local"
                      defaultValue={resultDate}
                      InputLabelProps={{
                        shrink: true,
                        fontSize: "18px",
                      }}
                      onChange={(e) => {
                        setEventLiveDate(e.target.value);
                      }}
                      sx={{ marginTop: "25px", width: "225px" }}
                    />

                    <Link
                      href="#"
                      className={classes.addMoreLink}
                      onClick={() => {
                        updatePollResult();
                      }}
                    >
                      + Choice
                    </Link>
                  </Box>

                  <Button
                    className={classes.btnPollSubmit}
                    onClick={(e) => {
                      createNewPoll("HIT_PREDICTOR");
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            </TabPanel>
          </Box>
        </Box>
      )}

      <Slide
        in={(showThread || displayRightPinnedThread) && selectedThread}
        direction="left"
      >
        <Box className={classes.modalSidebarContainer + " slideModalSidebar"}>
          <Box className={classes.threadBody}>
            <Box className={classes.threadHeader}>
              <Typography variant="h4">
                <Box
                  component="img"
                  src="/images/community/hashChat.svg"
                  width="24"
                  height="24"
                />{" "}
                {getMessageSubstr(threadDetails?.meta?.name)}
              </Typography>
              <List className={classes.optionIconList}>
                <ListItem>
                  {/* <Box
                    component="img"
                    src="/images/community/bell.svg"
                    width="24"
                    height="24"
                  /> */}
                </ListItem>
                <ListItem>
                  {/* <Box
                    component="img"
                    src="/images/community/dots-horizontal.svg"
                    width="24"
                    height="24"
                  /> */}
                </ListItem>
                <ListItem>
                  {selectedThread != displayRightPinnedThread && (
                    <Box
                      component="img"
                      onClick={closeThreadPopup}
                      src="/images/community/close.svg"
                      width="24"
                      height="24"
                      sx={{ cursor: "pointer" }}
                    />
                  )}
                </ListItem>
              </List>
            </Box>
            <Box className={classes.bodyContentScroll}>
              <Typography
                style={{
                  marginBottom: "0px",
                  marginTop: "10px",
                  fontSize: "18px",
                }}
              >
                <strong>{threadDetails?.meta?.name}</strong>
              </Typography>
              <Typography
                style={{ marginBottom: "5px", fontSize: "16px" }}
                component="p"
              >
                Started By{" "}
                <b style={{ color: "#E14084" }}>
                  {threadDetails?.meta?.user?.name}
                </b>
              </Typography>
              <Box className={classes.threadMsgDate}>
                <Typography
                  variant="span"
                  style={{ fontSize: "12px", fontWeight: "500" }}
                >
                  {moment(threadDetails?.meta?.createdAt).format("DD MMM YYYY")}
                </Typography>
              </Box>
              <div
                id="scrollableDiv"
                className="scroll-content"
                onScroll={(event) => {
                  if (
                    Math.ceil(
                      event.target.offsetHeight + event.target.scrollTop
                    ) >= Math.floor(event.target.scrollHeight) &&
                    !loadingUnreadList &&
                    threadUnreadCount
                  ) {
                    resetLastSeenTimeStamp(
                      displayThreadMessageList[
                        displayThreadMessageList?.length - 1
                      ]?.createdAt
                    );
                  }
                }}
              >
                {displayThreadMessageList?.map((item, key) => {
                  let unreadCount = threadUnreadCount;
                  return (
                    <>
                      {threadUnreadCount && key == threadMessageList.length ? (
                        <Box>
                          <UnreadMessagesStrip
                            unreadMesageCount={threadUnreadCount}
                            onClickJumpToPresent={jumpToPresent}
                            isMobile
                          />
                        </Box>
                      ) : (
                        <></>
                      )}
                      {item?.type == "predictor" ? (
                        <HitPredictor
                          message={item}
                          setSelectedSong={handleNewSongSelect}
                          playedSeconds={playedSeconds}
                          selectedSong={selectedSong}
                          totalDuration={totalDuration}
                          isPlaying={isSongPlaying}
                          pauseSong={pauseSong}
                          playSong={playSong}
                          setSongList={setSongList}
                          isMobile={isMobile}
                          refreshHitpredictorMessage={refreshHitpredictor}
                          // refreshMessages={refreshMessages}
                        />
                      ) : (
                        <></>
                      )}
                      {item?.type == "poll" ? (
                        <PollMessage message={item} />
                      ) : (
                        <></>
                      )}

                      {item?.type != "poll" && item?.type != "predictor" ? (
                        <ListItem
                          key={key}
                          sx={{
                            margin: "0px 0px 0px !important",
                            padding: "0px 16px 0px 0px !important",
                          }}
                        >
                          <Box
                            className="message_wrap"
                            ref={
                              key == threadMessageList.length - 1 &&
                              !threadUnreadCount
                                ? itemRef
                                : null
                            }
                            sx={{
                              paddingLeft: "0px",
                              paddingRight: "0px",
                              width: "100%",
                            }}
                          >
                            <ParentMessage item={item} />

                            <Box
                              className={
                                classes.userActionInfo + " user_action_info"
                              }
                            >
                              <Box className={classes.userInfo}>
                                <Box
                                  sx={{ width: "35px", height: "35px" }}
                                  ref={
                                    key == threadMessageList.length &&
                                    threadUnreadCount
                                      ? itemRef
                                      : null
                                  }
                                >
                                  {item?.user?.profilePic ? (
                                    <Box
                                      component="img"
                                      src={item?.user?.profilePic}
                                      width="35px"
                                      height="35px"
                                      sx={{
                                        width: "35px !important",
                                        maxWidth: "initial",
                                        borderRadius: "18px",
                                      }}
                                      backgroundColor={
                                        item?.user?.profileBgColor
                                          ? item?.user?.profileBgColor +
                                            "!important"
                                          : "#e14084"
                                      }
                                    />
                                  ) : (
                                    <Box
                                      width="35px"
                                      height="35px"
                                      borderRadius={"18px"}
                                      // backgroundColor="#e14084"
                                      backgroundColor={
                                        item?.user?.profileBgColor
                                          ? item?.user?.profileBgColor +
                                            "!important"
                                          : "#e14084"
                                      }
                                      sx={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        display: "flex",
                                        flex: 1,
                                        color: "#FFF",
                                        width: "35px !important",
                                        fontSize: "18px",
                                        fontWeight: "bold",

                                        maxWidth: "initial",
                                      }}
                                    >
                                      {getUserProfilePic(item?.user?.name)}
                                    </Box>
                                  )}
                                </Box>
                                <Box className={classes.userNameDT}>
                                  <Box className={classes.threadProfiledetails}>
                                    <Typography
                                      component="p"
                                      className={classes.userName}
                                      sx={{
                                        color:
                                          item?.user?.role == "admin"
                                            ? "blue"
                                            : "",
                                      }}
                                    >
                                      {item?.user?.name}
                                    </Typography>
                                    <Typography component="small">
                                      {moment(item?.createdAt).fromNow()}
                                    </Typography>
                                  </Box>

                                  {selectedMessage &&
                                  selectedMessage._id == item._id ? (
                                    <EditMessage
                                      item={item}
                                      handleCancel={() => {
                                        setSelectedMessage(null);
                                      }}
                                      handleEditSubmit={(e) => {
                                        handleEditSubmit(key, e);
                                      }}
                                    />
                                  ) : (
                                    <Typography
                                      component="p"
                                      className={classes.userDT}
                                      sx={{
                                        wordBreak: "break-word !important",
                                      }}
                                    >
                                      <MessageDetail
                                        item={item}
                                        isMobile={true}
                                      />
                                    </Typography>
                                  )}
                                </Box>

                                {(!selectedMessage ||
                                  selectedMessage._id != item._id) && (
                                  <ThreadMessageActionButton
                                    item={item}
                                    user={user}
                                    handleDelete={(e) => {
                                      // handleDelete(key, item);
                                      handleOpen(key, item);
                                    }}
                                    handleReaction={(e) => {
                                      console.log(
                                        "Print item in ThreadMessage Reaction",
                                        e
                                      );
                                      handleReaction(e, item);
                                      dispatch(setRefreshThreadMessages(true));
                                    }}
                                    handleEdit={() => {
                                      console.log(
                                        "Print item in ThreadMessageActionButton",
                                        item
                                      );
                                      setSelectedMessage(item);
                                    }}
                                    handleThreadMessageReport1={(e) => {
                                      handleOpen1(key, item);
                                    }}
                                    isMobile={isMobile}
                                  />
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </ListItem>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
                {unseenThreadMessageList.length ? (
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: "-90px",
                      left: "0px",
                      width: "100%",
                      height: "34px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      display: "flex",
                      background: "#ddd",
                      padding: "1px 0px 1px 0px ",
                      opacity: 1,
                      zIndex: 1,
                    }}
                    onClick={() => {
                      viewUnseenThreadMessages();
                    }}
                    className="strip_background"
                  >
                    <Box
                      style={{
                        width: "100%",
                        background: "#fff",
                        color: "#E14084",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "15px",
                        height: "32px",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <span>
                        You have{" "}
                        {unseenThreadMessageList.length > 100
                          ? "100+"
                          : unseenThreadMessageList.length}{" "}
                        new messages
                      </span>
                    </Box>
                  </Box>
                ) : (
                  <></>
                )}
              </div>
            </Box>
            <Box className={classes.messageContainer + " emojiBox"}>
              {selectedThread && <ThreadMessageBox threadId={selectedThread} />}
            </Box>
          </Box>
        </Box>
      </Slide>

      {isOpenModal && (
        <Box>
          {selectedSong && selectedSong?.songType == "audio" ? (
            <Box>
              <ReactPlayer
                onProgress={(progress) => {
                  setPlayedSeconds(progress?.playedSeconds);
                }}
                width={"0px"}
                height={"0px"}
                background={"transparent"}
                controls
                url={
                  selectedSong?.youtubeId
                    ? `https://www.youtube.com/watch?v=${selectedSong?.youtubeId}`
                    : selectedSong?.songUrl
                }
                playing={isSongPlaying}
                config={{
                  file: { attributes: { controlsList: "nodownload" } },
                }}
                onDuration={(duration) => {
                  setToalDuration(duration);
                }}
                onPause={() => {
                  setIsSongPlaying(false);
                }}
                onPlay={() => {
                  setIsSongPlaying(true);
                }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                width: "301px",
                height: "217px",
                position: "absolute",
                bottom: "30px",
                right: "20px",
                zIndex: 80000,
              }}
            >
              <Box
                component="img"
                src={"/images/home/modal-close-white.svg"}
                sx={{
                  width: "12px",
                  height: "12px",
                  position: "absolute",
                  bottom: "195px",
                  right: "5px",
                  zIndex: 100000,
                  cursor: "pointer",
                }}
                onClick={() => {
                  pauseSong();
                  setIsOpenModal(false);
                }}
              />
              <ReactPlayer
                onProgress={(progress) => {
                  setPlayedSeconds(progress?.playedSeconds);
                }}
                width={"301px"}
                height={"217px"}
                controls
                url={getRecommendation(selectedSong)}
                playing={isSongPlaying}
                config={{
                  file: { attributes: { controlsList: "nodownload" } },
                }}
                onDuration={(duration) => {
                  setToalDuration(duration);
                }}
                onPause={() => {
                  setIsSongPlaying(false);
                }}
                onPlay={() => {
                  setIsSongPlaying(true);
                }}
              />
            </Box>
          )}
        </Box>
      )}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        disableScrollLock={true}
      >
        <Box className={classes.modalContainer}>
          <Box
            component="img"
            src="/images/payment/popup-close.svg"
            sx={classes.btnClose}
            width="24"
            height="24"
            onClick={() => setOpen(false)}
          />
          <Typography variant="h4">Sure you want to delete?</Typography>
          <Typography component="span">
            This message will be deleted immediately. You can’t undo this
            action.
          </Typography>

          <Box className={classes.modalBtnContainer}>
            <Button
              onClick={() => setOpen(false)}
              className={classes.btnCancel}
            >
              Cancel
            </Button>
            <Button
              className={classes.btnDeleteMessgae}
              contained="solid"
              onClick={() =>
                handleClose(deleteThreadMessageindex, deleteThreadmessageArray)
              }
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={open1} disableScrollLock={true}>
        <Box className={classes.msgOverflowScroll}>
          <Box
            component="img"
            src="/images/community/modal-close.svg"
            onClick={() => handleClose1(flagmessageindex, flgmessageArray)}
          />
          <Typography variant="p">
            Please enter feedback for reported Message Content
          </Typography>

          <textarea
            id="flag_content"
            Rows={3}
            placeholder={"Type a Comment"}
            onChange={(e) => {
              setFlagmessage(e.target.value);
            }}
            onKeyPress={handleEnter}
            value={flagmessage}
            className="form-control"
          ></textarea>
          <Button
            variant="outlined"
            style={{ border: "red" }}
            onClick={() => handleClose1(flagmessageindex, flgmessageArray)}
          >
            Submit
          </Button>
        </Box>
      </Modal>

      {/* reaction limit popup */}
      <Modal
        open={show}
        onClose={() => setShow(false)}
        aria-labelledby="How It Works"
        aria-describedby="modal-modal-description"
      >
        <Box sx={nftLandingCss.modalreactionContainer}>
          <Box sx={nftLandingCss.modalHeader}>
            <Typography variant="h4" sx={nftLandingCss.modalreactionTitle}>
              WE APPRECIATE THE ENTHUSIASM, BUT...
            </Typography>
            <button
              type="button"
              className=" close"
              style={{
                zIndex: "2",
                position: "absolute",
                top: "15px",
                right: "15px",
              }}
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <span aria-hidden="true">
                <img
                  src="/images/community/modal-close.svg"
                  style={{ width: "18px", height: "18px" }}
                />
              </span>
            </button>
          </Box>
          <Box sx={nftLandingCss.modalBody}>
            <Typography variant="span" style={{ color: "black" }}>
              Your reaction was not added because there are too many reactions
              on this message.
            </Typography>
          </Box>

          <Box sx={nftLandingCss.modalFooter}>
            <Button
              variant="contained"
              sx={nftLandingCss.okeybtnCSS}
              onClick={() => setShow(false)}
            >
              Okay
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
function TabPanel(props) {
  const { children, value, index } = props;
  return <div>{value === index && <h1>{children}</h1>}</div>;
}
export default CommunityMember;
